export default function ChatgptSomeFacebook() {
  return <h2>Chatgpt Some Facebook</h2>;
}
